import type { Board } from "../../board";
import { PRIORITY_DEFAULT, type ProcessableThing } from "../../interfaces";
import { Mob } from "../../mob";
import { PhysicalThing } from "../../physicalThing";
import { deserializeXY } from "../../serialization";
import type { XY } from "../../xy";
import { breadthFirstSearch } from "../../levelgenerator/levelGeneratorUtils";

export class NoMobsInAreaAction extends PhysicalThing implements ProcessableThing {
	static key = "NoMobsInAreaAction";
	private action: () => void;

	constructor(xy: XY, action: () => void = () => {}) {
		super(xy, false);
		this.action = action;
	}

	processTurn(board: Board): void {
		if (this.getNumberOfMobsInArea(board) <= 0) {
			this.action();
			board.removeAtEndOfTurn(this);
		}
	}

	private getNumberOfMobsInArea(board: Board): number {
		const area = breadthFirstSearch(this.xy, (p) => board.isPassable(p));
		const areaSet = new Set(area.map((xy) => xy.toString()));
		return board
			.getPhysicalThings()
			.filter((t) => t instanceof Mob)
			.filter((t) => areaSet.has(t.xy.toString())).length;
	}

	getProcessPriority(): number {
		return PRIORITY_DEFAULT;
	}

	getZOrder(): number {
		return 0;
	}

	isVisible(): boolean {
		return false;
	}

	static deserialize(data: any): NoMobsInAreaAction {
		const n = new NoMobsInAreaAction(deserializeXY(data.xy));
		n.visualId = data.visualId;
		return n;
	}
}
